import axios from 'axios';
import { ProductGroupFeatureValue } from '@utils/pageConfig/Types';
import { environment } from '@environments/environment';
import { ProductType } from '@pages/product-analyzer/Product';

export interface FeatureValueByPGListParam {
  clientId: number;
  productType: ProductType;
  country: string[];
  periodType: string;
  productGroup: string[];
  productDataType: ProductType;
}

/*
 * function that gets the feature values/filter & filter options based on retailer+country+periodType+PG
 */
export const getFeatureValueByPGList = async (
  param: FeatureValueByPGListParam,
  controller: AbortController,
): Promise<ProductGroupFeatureValue[]> => {
  try {
    const { data } = await axios.post<ProductGroupFeatureValue[]>(
      `${environment.baseUrl}/v2/filters/product-group-feature-value-list`,
      {
        clientId: param.clientId,
        productType: param.productType,
        country: countryListToUpperCase(param.country),
        periodType: periodTypeToUpperCase(param.periodType),
        productGroup: productGroupListToUpperCase(param.productGroup),
        productDataType: param.productDataType,
      },
      {
        signal: controller.signal,
      },
    );
    return data;
  } catch (err: any) {
    console.error(`An error has occurred: ${err}`);
    return [];
  }
};

/**
 * Convert each of the product group in the product group list to upper case
 * @param productGroupList product group list
 */
const productGroupListToUpperCase = (productGroupList: string[]): string[] => {
  return productGroupList.map((productGroup) => productGroup.toUpperCase());
};

/**
 * Convert each of the country in the country list to upper case
 * @param countryList country list
 */
const countryListToUpperCase = (countryList: string[]): string[] => {
  return countryList.map((country) => country.toUpperCase());
};

/**
 * Convert period type to upper case (if period type is undefined, do nothing)
 * @param periodType period type (Monthly or Weekly)
 */
const periodTypeToUpperCase = (periodType: string): string => {
  return periodType?.toUpperCase();
};
